import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import {
    AddCustomListItemsRequest,
    CustomListDetail,
} from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const addCustomListItems = createAsyncThunk<
    CustomListDetail,
    AddCustomListItemsRequest,
    ThunkConfig<string | string[]>
>('customList/addCustomListItems', async ({ listId, data }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.post<CustomListDetail>(
            `/v1/custom-lists/${listId}/items`,
            data,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue(getApiErrorMessage(e));
    }
});
